import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { format } from 'date-fns';
import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
import {
  getLabelRole,
  getLabelStatus,
} from '@/features/users/components/users-table/users-table.tsx';
import { useSession } from '@/services/providers/session-provider.tsx';

export function AccountInformationCard() {
  const user = useSession();

  return (
    <DashboardCard className="min-h-[265px] border p-4" isLoading={user.isLoading}>
      <CardHeader className="p-0">
        <CardTitle>Account Information</CardTitle>
        <CardDescription>View your account details and status.</CardDescription>
      </CardHeader>
      <CardContent className="p-0">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="space-y-4">
            <div>
              <Label className="text-muted-foreground text-sm font-medium">Status</Label>
              <div className="mt-1">
                <Badge variant={getLabelStatus(user.status)}>{user.status}</Badge>
              </div>
            </div>

            <div>
              <Label className="text-muted-foreground text-sm font-medium">Role</Label>
              <div className="mt-1">
                <Badge variant={getLabelRole(user.role)}>{user.role}</Badge>
              </div>
            </div>

            {user.subscriptionType && (
              <div>
                <Label className="text-muted-foreground text-sm font-medium">
                  Subscription
                </Label>
                <p className="mt-1 text-sm capitalize">{user.subscriptionType}</p>
              </div>
            )}
          </div>

          <div className="space-y-4">
            {user.createdAt && (
              <div>
                <Label className="text-muted-foreground text-sm font-medium">
                  Member Since
                </Label>
                <p className="mt-1 text-sm">
                  {format(new Date(user.createdAt), 'MMMM d, yyyy')}
                </p>
              </div>
            )}

            {user.preferredLocale && (
              <div>
                <Label className="text-muted-foreground text-sm font-medium">Language</Label>
                <p className="mt-1 text-sm">{user.preferredLocale}</p>
              </div>
            )}

            {user.themePref && (
              <div>
                <Label className="text-muted-foreground text-sm font-medium">Theme</Label>
                <p className="mt-1 text-sm capitalize">{user.themePref}</p>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </DashboardCard>
  );
}
